module.exports = __webpack_public_path__ + "img/amendiades2.0e21f726.png";